import React, { useEffect, useState } from "react";
import axios from "axios";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import ResponsiveDrawer from "../components/ResponsiveDrawer";
import ClientsTable from "../components/ClientsTable";
import ProgressBar from "../components/ProgressBar";
import {
  Box,
  Grid,
  TextField,
  IconButton,
  Typography,
  Stack,
  Button,
  Paper,
  Modal,
  LinearProgress,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { makeStyles } from "@material-ui/core";
import * as MdIcons from "react-icons/md";

const useStyles = makeStyles((theme) => ({
  root: {
    minHeight: "100vh",
    backgroundColor: "#F7F8FA",
  },
  toolbar: {
    height: "64px",
  },
  stack: {
    backgroundColor: "#ffff",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "12px",
    padding: "12px",
    boxShadow: "0px 2px 6px #0000000a",
    // height: "180px",
    // [theme.breakpoints.down("md")]: {
    //   height: "230px",
    // },
  },
  balance: {
    fontSize: "30px !important",
    fontWeight: "bold !important",
    color: "#006EFF",
  },
  paperDownload: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#4CAF50 !important",
    borderRadius: "10px",
    padding: "8px",
    cursor: "pointer",
  },
}));

function Clients(props) {
  const classes = useStyles();

  const [clientsNumber, setClientsNumber] = useState(0);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(true);
  const [exportLoading, setExportLoading] = useState(false);
  const [openFailed, setOpenFailed] = useState(false);
  const [openWait, setOpenWait] = useState(false);

  // console.log("clients", clients);

  let tokenStorage = null;

  useEffect(() => {
    requestClients();
  }, []);

  const requestClients = async () => {
    await axios
      .get(`https://bck-bdx.carloapp.com/api/business/my_sales`, {
        params: { filter: 4 },
        method: "GET",
        headers: {
          Version: "4.0",
          Authorization: `Bearer ${tokenStorage}`,
        },
      })
      .then((res) => {
        // console.log(">>res", res);
        if (res.data.status === true) {
          setClientsNumber(res.data.data.count);
          setClients(res.data.data.data);
          setLoading(false);
        }
      });
  };

  const exportClients = async () => {
    setExportLoading(true);
    setOpenWait(true);
    await axios
      .get(`https://bck-bdx.carloapp.com/api/business/my_sales/export`, {
        params: { filter: 4 },
        method: "GET",
        responseType: "blob",
        headers: {
          Version: "4.0",
          Authorization: `Bearer ${tokenStorage}`,
        },
      })
      .then((res) => {
        const blob = res.data;
        if (blob.type === "application/json") {
          setOpenFailed(true);
          setExportLoading(false);
          setOpenWait(false);
        } else {
          setExportLoading(false);
          setOpenWait(false);
          const url = window.URL.createObjectURL(new Blob([res.data]));
          const link = document.createElement("a");
          link.href = url;
          const date = new Date();
          const day = date.getDate();
          const month = date.getMonth() + 1;
          const year = date.getFullYear();
          link.setAttribute("download", `clients-${day}-${month}-${year}.xlsx`);
          document.body.appendChild(link);
          link.click();
          link.remove();
        }
      })
      .catch((error) => {
        setExportLoading(false);
        setOpenWait(false);
        setOpenFailed(true);
      });
  };

  // Redirect user if not logged in
  let isLoggedIn = localStorage.getItem("token");
  if (isLoggedIn) {
    tokenStorage = isLoggedIn.slice(1, isLoggedIn.length - 1);
  }
  // console.log(">>local storage", isLoggedIn);
  if (!props.token && !isLoggedIn) {
    return <Redirect to="/" />;
  }
  if (!props.token && isLoggedIn) {
    props.onSetToken(tokenStorage);
  }

  return (
    <Box sx={{ flexGrow: 1, display: "flex" }}>
      <ResponsiveDrawer />

      <Box className={classes.root} sx={{ flexGrow: 1, p: 3 }}>
        <div className={classes.toolbar}></div>

        {loading ? (
          <ProgressBar />
        ) : (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <h2>Mes clients</h2>
            </Grid>
            <Grid>
              <ClientsTable 
                clients={clients} 
                number={clientsNumber}
                onExport={exportClients}
                exportLoading={exportLoading}
              />
            </Grid>
          </Grid>
        )}

        {/* Modal to show progress/wait */}
        <Modal open={openWait}>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "#fff",
              p: 4,
              borderRadius: 5,
            }}
          >
            <LinearProgress />
          </Box>
        </Modal>

        {/* Modal to show export error */}
        <Modal open={openFailed}>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 400,
              bgcolor: "#fff",
              p: 4,
              borderRadius: 5,
            }}
          >
            <IconButton color="error">
              <MdIcons.MdError size={48} />
            </IconButton>
            <Typography mb={2}>
              Une erreur s'est produite lors de l'export. Veuillez réessayer.
            </Typography>
            <Button
              color="primary"
              variant="contained"
              onClick={() => setOpenFailed(false)}
            >
              Fermer
            </Button>
          </Box>
        </Modal>
      </Box>
    </Box>
  );
}

function mapDispatchToProps(dispatch) {
  return {
    onSetToken: function (token) {
      dispatch({ type: "setToken", token: token });
    },
  };
}

function mapStateToProps(state) {
  return { token: state.token };
}

export default connect(mapStateToProps, mapDispatchToProps)(Clients);
